<template>
    <div>
        <home-header @getCity="getCity"></home-header>
        <div class="wrapper expo_wrapper">
            <!-- 入驻-->
            <div class="cooperate_wrapper">
                <img src="../assets/image/expo/expo_bg.jpg" alt="" class="cooperate_img">
                <div class="sq_btn">
                    <p class="big_title">参展商入驻</p>
                    <p class="btn" @click="handleApply"> >> 点击申请</p>
                </div>
            </div>
            <div class="wrap">
                <!--家博会简介-->
                <img src="../assets/image/expo/introduce_title.png" alt="" class="title_img">
                <div>
                    <template v-for="(item,index) in introduce_list">
                        <div class="introduce_wrap mb60" :key="index">
                            <div class="l_text">
                                全国超大规模建材家装展销会将于2024年3月-10
                                日在邯郸大剧院(美乐城对面)开展，汇聚家装、建材、
                                家具、卫浴陶瓷、木门、地板、橱柜、电器、家访等全
                                品类产品。本届家博会凭票入场，家博会组委会将面
                                向全市限时限量发放免费VIP门票。凡现场下订用户凭
                                乐居家博会专用订单+VIP贵宾门票即可参与实物兑奖(
                                单单有礼，100万豪礼超值惠送)、现金抽奖(100%中
                                奖，单笔100-4999元现金奖)、超值换购、拆盲盒抽锦
                                鲤等优惠活动。展前在线上成功升级PLUS会员，即可
                                领取精美到场礼、返现券、打车券、会员专属商品抢
                                购、免费咖啡等权益。家博会开展期间，您可以看您想
                                看的产品，现场询价、比价、砍价一步到位。赶紧报名
                                领取VIP家庭套票免费逛展，现场惊喜不断!
                            </div>
                            <div class="r_img">
                                <img :src="item.thumb" alt="" @click="clk_link(item.link)"/>
                            </div>
                        </div>
                    </template>
                </div>
                <!--排期-->
                <div class="activity_wrap">
                    <template v-for="(item,index) in activity_img_list">
                        <img :src="item.thumb" :key="index" @click="clk_link(item.link)"/>
                    </template>
                </div>
                <!--活动案例-->
                <img src="../assets/image/expo/activity_title.png" alt="" class="title_img">
                <div class="swiper_box">
                    <!-- 左按钮-->
                    <div class="img_box">
                        <img src="../assets/image/coms/left.png" alt="" class="btn_img" @click="imageClick('left')"
                             v-if="currPage>1"/>
                    </div>
                    <!-- 中间轮播-->
                    <div class="banner_box" v-if="activity_list.length">
                        <el-carousel arrow="never" indicator-position="none" :autoplay="false" ref="banner"
                                     class="banner">
                            <el-carousel-item
                                v-for="(item, index) in Math.ceil(activity_list.length / 4)"
                                :key="index"
                                class="activity_list"
                            >
                                <div v-for="(el, ind) in activity_list.slice((item - 1)*4, item*4)" :key="ind"
                                     class="news_item activity_item" @click="clk_info(el)">
                                    <img :src="el.thumb" class="l_img">
                                    <div class="news_info r_text">
                                        <p class="text-overflow_title title r_title">{{el.title}}</p>
                                        <p class="text-overflow info r_info">{{el.describe}}</p>
                                    </div>
                                </div>
                            </el-carousel-item>
                        </el-carousel>
                    </div>
                    <div v-else class="wait_box">敬请期待...</div>
                    <!-- 右按钮-->
                    <div class="img_box">
                        <img src="../assets/image/coms/right.png" alt="" class="btn_img" @click="imageClick('right')"
                             v-if="activity_list.length!=0"/>
                    </div>
                </div>
                <!--合作品牌-->
                <img src="../assets/image/expo/brand_title.png" alt="" class="title_img" v-if="cooperate_img.length > 0">
                <div v-for="(item, index) in cooperate_img">
                    <img :key="index" :src="item.thumb" alt="" class="mb60" style="width: 100%;"/>
                </div>
                <!--展品范围-->
                <img src="../assets/image/expo/shows_title.png" alt="" class="title_img">
                <div class="brand_wrap">
                    <ul>
                        <li v-for="(item,index) in brand_list" :key="index">
                            <img :src="item.url" alt="">
                            <span>{{item.text}}</span>
                        </li>
                    </ul>
                </div>
                <!--官方账号-->
                <account></account>
            </div>

        </div>
        <!--底部-->
        <copyright></copyright>

        <!-- 参展商入驻弹框 -->
        <div class="settlein_fixed" v-show="settleFlag">
            <div class="close_wrap">
                <span @click="settleFlag = false">X</span>
            </div>
            <div class="form_continer">
                <h3>入驻申请</h3>
                <el-form :model="ruleForm" ref="ruleForm" class="settlein_form">
                    <el-form-item>
                        <el-input v-model="ruleForm.name" placeholder="您的姓名"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-input v-model="ruleForm.phone" placeholder="您的电话"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-input v-model="ruleForm.industry" placeholder="您的参展行业"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <div class="submit_btn" @click="submitForm('ruleForm')">报名参展</div>
                    </el-form-item>
                </el-form>
            </div>
        </div>

        <!--报名成功弹框-->
        <!-- 报名成功-->
        <el-dialog
            :visible.sync="success_dialog"
            width="15%"
            center>
            <el-result icon="success" title="报名成功"></el-result>
        </el-dialog>
    </div>
</template>

<script>
    import HomeHeader from "../components/whiteheader";
    import Account from "../components/account";
    import Copyright from "../components/copyright";
    import _regular from "../utils/_regular";
    import lib_website from "../libs/lib_website";


    let brand_list = [
        {
            id: 1,
            url: require('../assets/image/expo/brand/brand_01.png'),
            text: '陶瓷'
        },
        {
            id: 2,
            url: require('../assets/image/expo/brand/brand_02.png'),
            text: '家电'
        },
        {
            id: 3,
            url: require('../assets/image/expo/brand/brand_03.png'),
            text: '木门'
        },
        {
            id: 4,
            url: require('../assets/image/expo/brand/brand_04.png'),
            text: '地板'
        },
        {
            id: 5,
            url: require('../assets/image/expo/brand/brand_05.png'),
            text: '灯饰'
        },
        {
            id: 6,
            url: require('../assets/image/expo/brand/brand_06.png'),
            text: '厨电'
        },
        {
            id: 7,
            url: require('../assets/image/expo/brand/brand_07.png'),
            text: '卫浴'
        },
        {
            id: 8,
            url: require('../assets/image/expo/brand/brand_08.png'),
            text: '橱柜'
        },
        {
            id: 9,
            url: require('../assets/image/expo/brand/brand_09.png'),
            text: '壁纸'
        },
        {
            id: 10,
            url: require('../assets/image/expo/brand/brand_10.png'),
            text: '家纺'
        },
        {
            id: 11,
            url: require('../assets/image/expo/brand/brand_11.png'),
            text: '全屋定制'
        },
        {
            id: 12,
            url: require('../assets/image/expo/brand/brand_12.png'),
            text: '装修公司'
        }
    ]
    export default {
        name: "expo",
        components: {
            Copyright,
            Account,
            HomeHeader
        },
        data() {
            return {
                activity_img_list: [], // 排期
                cooperate_img: [], // 合作品牌
                activity_list: [], //活动案例
                brand_list: brand_list,
                introduce_list: [], //公司简介
                currPage: 1,
                settleFlag: false,
                city: 'handan',
                ruleForm: {
                    name: '',
                    phone: '',
                    industry: ''
                },
                success_dialog: false, //成功弹框
                expo: {}, //
            }
        },
        created() {
            // 城市列表
        },
        methods: {
            // 获取城市
            getCity(city) {
                lib_website.plan(this.init_plan)
                lib_website.ui(7, 1, this.init_introduce)
                lib_website.ui(4, 1, this.init_cooperate)
                this.select_page(1)
                lib_website.expo(this.init_expo)
            },
            select_page(page) {
                lib_website.news(3, page, 4, this.init_news_list)
            },
            init_news_list(data) {
                console.log(data)
                this.activity_list = data;
            },
            init_plan(data) {
                this.activity_img_list = data
            },
            init_introduce(data) {
                this.introduce_list = data
                console.log(data, '案例===')
            },
            init_cooperate(data) {
                console.log(data)
                this.cooperate_img = data
            },
            init_expo(data) {
                this.expo = data
            },
            // 图片链接
            clk_link(link) {
                // todo 富文本
                // if (link) {
                //
                //     window.location.href = link
                // }
            },
            //
            handleApply() {
                this.settleFlag = !this.settleFlag
            },
            // 表单提交
            submitForm(formName) {
                // 校验
                if (!this.ruleForm.name) {
                    this.$message.info('请输入您的姓名');
                    return
                }
                if (this.ruleForm.name && this.ruleForm.name.length > 20) {
                    this.$message.info('请输入您正确的姓名');
                    return
                }
                if (!this.ruleForm.phone) {
                    this.$message.info('请输入您的电话');
                    return;
                }
                if (!_regular.is_mobile(this.ruleForm.phone)) {
                    this.$message.info('请输入正确的电话');
                    return;
                }
                if (!this.ruleForm.industry) {
                    this.$message.info('请输入您的参展行业');
                    return;
                }

                let that = this;
                that.$refs[formName].validate((valid) => {
                    if (valid) {

                        lib_website.exhibitor(that.ruleForm.phone, that.ruleForm.name, that.ruleForm.industry, function (data) {
                            that.success_dialog = true
                            setTimeout(() => {
                                that.success_dialog = false
                                that.ruleForm = {}
                                that.settleFlag = false
                            }, 1000)
                        })

                    }
                });
            },
            // 轮播切换
            imageClick(val) {
                if (val == 'right') {
                    // 请求下一页
                    this.currPage++;
                    this.select_page(this.currPage)
                    this.$refs.banner.next()
                } else {
                    // 请求上一页
                    this.currPage--;
                    this.select_page(this.currPage)
                    if (this.$refs.banner) {
                        this.$refs.banner.prev()
                    }
                }
            },
            clk_info(item) {
                this.$router.push(`/info?id=${item.id}`)
            }
        }
    }
</script>

<style scoped lang="less">
    @import "../assets/style/pages/expo.less";
    @import "../assets/style/coms/banner.less";

    /deep/ .el-dialog {
        border-radius: 15px;
    }
</style>
